import {Dimensions, Platform} from "react-native";

const data = Dimensions.get('window');
export default {
    ...data,
    width: Platform.OS === "web" ? Math.min(data.width, 720) : data.width,
};